import { LanguageCode } from "common/types/languageCode";

const languageCodeStrings: string[] = Object.values(LanguageCode);

export const isLanguageCode = (value: string): value is LanguageCode => languageCodeStrings.includes(value);
